const getDayOfCurrentMonth = (preference = "last") => {
  var date = new Date(),
    year = date.getFullYear(),
    month = date.getMonth(),
    day =
      preference === "last"
        ? new Date(year, month + 1, 0)
        : new Date(year, month, 1);

  return day;
};

export default getDayOfCurrentMonth;
